import { Tag, styled } from '@project44/manifest-ui-deprecated';

export const DefaultTag = styled(Tag)(() => ({
  backgroundColor: 'fill.cerulean.50',
  borderRadius: 4,
  borderColor: 'transparent',
  color: 'fill.cerulean.900',
  paddingX: '0.25rem',
  paddingY: 'calc(0.25rem / 2)',
  ml: 2,
  height: '20px',
  '& > .manifestui-tag-text': {
    color: 'text.secondary',
    fontWeight: 600,
    px: '0.25rem',
    letterSpacing: '0.5px',
    fontSize: '12px',
  },
}));
